var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M10 18.541c-.259 0-.509-.033-.717-.108C6.099 17.341 1.04 13.466 1.04 7.741c0-2.916 2.358-5.283 5.258-5.283 1.409 0 2.725.55 3.7 1.533a5.178 5.178 0 0 1 3.7-1.533c2.9 0 5.259 2.375 5.259 5.283 0 5.734-5.059 9.6-8.242 10.692a2.157 2.157 0 0 1-.717.108ZM6.3 3.708c-2.209 0-4.009 1.808-4.009 4.033 0 5.692 5.475 8.859 7.4 9.517.15.05.475.05.625 0 1.917-.658 7.4-3.817 7.4-9.517 0-2.225-1.8-4.033-4.008-4.033a3.96 3.96 0 0 0-3.2 1.617c-.234.316-.767.316-1 0a3.975 3.975 0 0 0-3.209-1.617Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLight);
export default __webpack_public_path__ + "static/media/heart-light.d246a28a1dc8d670f588c792fd4b2893.svg";
export { ForwardRef as ReactComponent };